
export const scrollHidden = (hidden) => {
    if (hidden) {

        document.getElementsByTagName("body")[0].style.overflow = "hidden"
    }
    if (!hidden) {
        document.getElementsByTagName("body")[0].style.overflow = "auto"
    }
}